import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from 'src/app/Services/report.service';

@Component({
  selector: 'ze-video-viewer-view',
  templateUrl: './video-viewer-view.component.html',
  styleUrls: ['./video-viewer-view.component.scss']
})
export class VideoViewerViewComponent implements OnInit {

  video_url: any = null;
  videoToken: string = null;
  videoNotFound: boolean = false;
  user = "";
  constructor(private route: ActivatedRoute,
    private reportService: ReportService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    let currentUser1 = JSON.parse(localStorage.getItem("currentUser")).token;
    this.user = this.parseJwt(JSON.stringify(currentUser1)).sub;
    this.route.params.subscribe(params => {
      this.video_url = null;
      this.videoNotFound = false;
      this.videoToken = params['token'];
      this.reportService.getVideoContentByToken(this.videoToken).subscribe((videoBlob: Blob) => {
        const videoUrl = URL.createObjectURL(videoBlob);
        this.video_url = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
        this.video_url = videoUrl;
      },
      (error) => {
        this.videoNotFound = true;
      });
    });


  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  };

}
